// Centralized performance-related knobs.
// Increase these values to delay loading heavier media.

export const DEFAULT_IMAGE_DELAY_MS = 0;

